<script lang="ts">
  import { AppState } from '../../../etc/stores';

  const { primary200, primary600 } = $AppState.theme.colors;
</script>

<svg
  width="40"
  height="40"
  viewBox="0 0 40 40"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <rect width="40" height="40" rx="8" fill={primary600} />
  <path
    d="M28 26.6675V31.3341"
    stroke={primary200}
    stroke-width="1.90909"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M25.666 29.001H30.3327"
    stroke={primary200}
    stroke-width="1.90909"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M10 20.2564C10 14.6154 14.5277 10 20.0616 10C25.5955 10 30.1232 14.6154 29.9974 19.7436C29.9974 21.3016 29.652 22.7814 29.0354 24.1073C28.7014 24.037 28.355 24 28 24C25.2386 24 23 26.2386 23 29C23 29.1696 23.0084 29.3373 23.0249 29.5025C22.0506 29.8254 21.0122 30 19.9358 30C18.9297 30 17.9235 29.8718 17.0431 29.6154C17.4204 28.9744 17.7977 28.2051 18.0493 27.4359C18.175 26.9231 18.8039 24.6154 18.8039 24.6154C19.1812 25.2564 20.1874 25.8974 21.3193 25.8974C24.5893 25.8974 26.7274 22.8205 26.7274 18.8462C26.7274 15.7692 24.212 12.9487 20.3131 12.9487C15.5339 12.9487 13.1443 16.4103 13.1443 19.359C13.1443 21.1538 13.7731 22.6923 15.1566 23.3333C15.4081 23.4615 15.5339 23.3333 15.6597 23.0769C15.7854 22.9487 15.9112 22.4359 15.9112 22.3077C16.0001 22.1264 15.9633 22.0733 15.8896 21.9671C15.8591 21.9231 15.8223 21.87 15.7854 21.7949C15.4081 21.2821 15.1566 20.641 15.1566 19.7436C15.1566 17.1795 17.0431 14.8718 20.0616 14.8718C22.7028 14.8718 24.212 16.5385 24.212 18.8462C24.212 21.9231 22.9543 24.359 21.0678 24.359C19.9358 24.359 19.1812 23.4615 19.4328 22.4359C19.5378 21.9007 19.7085 21.3432 19.8718 20.81C20.0997 20.0659 20.3131 19.369 20.3131 18.8462C20.3131 17.9487 19.8101 17.3077 18.9297 17.3077C17.9235 17.3077 17.0431 18.4615 17.0431 20C17.0431 21.0256 17.4204 21.6667 17.4204 21.6667C17.4204 21.6667 16.4143 26.4103 16.1627 27.3077C16.037 28.0769 16.037 28.846 16.037 29.6152V29.6154C12.5154 28.0769 10 24.4872 10 20.2564Z"
    fill={primary200}
  />
</svg>
